import { render, staticRenderFns } from "./Minimize.vue?vue&type=template&id=5b5a8c1c&scoped=true&"
import script from "./Minimize.vue?vue&type=script&lang=js&"
export * from "./Minimize.vue?vue&type=script&lang=js&"
import style0 from "./Minimize.vue?vue&type=style&index=0&id=5b5a8c1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5a8c1c",
  null
  
)

export default component.exports